module.exports = __webpack_public_path__ + "img/2022-10.55add3ca.jpg";